import { dataStarDashSoild } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStarDashSoild = /*#__PURE__*/createIcon(dataStarDashSoild)
/** @deprecated */
export default IconStarDashSoild
